"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/Button";
import { HeroPattern } from "@/components/ui/HeroPattern";

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        // Log the error to an error reporting service
        console.error(error);
    }, [error]);

    return (
        <>
            <HeroPattern />
            <div className="mx-auto flex h-full max-w-xl flex-col items-center justify-center py-16 text-center">
                <h1 className="text-6xl font-bold text-zinc-900 dark:text-white mb-6">
                    SplatX
                </h1>
                <p className="text-sm font-semibold text-zinc-900 dark:text-white">
                    Error
                </p>
                <h1 className="mt-2 text-2xl font-bold text-zinc-900 dark:text-white">
                    Something went wrong!
                </h1>
                <p className="mt-2 text-base text-zinc-600 dark:text-zinc-400">
                    {error.message || "An unexpected error occurred."}
                </p>
                <div className="mt-8 flex gap-4">
                    <Button onClick={() => reset()} arrow="right">
                        Try again
                    </Button>
                    <Button href="/" variant="outline">
                        Back to Home
                    </Button>
                </div>
            </div>
        </>
    );
}
